import { useApiQuery } from '@portals-platform/api-client';
import { useMemo } from 'react';
import { ENDPOINTS } from '../api/endpoints.js';
import type { LocationLimitResponse } from '../api/responses.js';
import { toStorageLocationOptions } from '../mappers/mappers.js';
import { queryKeys } from '../query-keys.js';

function useLocationLimits(policyYear: string, countryCode: string) {
  return useApiQuery<LocationLimitResponse[]>(
    [...queryKeys.locationLimits(policyYear, countryCode)],
    ENDPOINTS.locationLimits,
    { params: { policyYear, countryCode } },
    { enabled: Boolean(policyYear && countryCode) },
  );
}

export function useStorageLocationOptions({
  policyYear,
  countryCode,
  countryName,
}: {
  policyYear: string;
  countryCode: string;
  countryName: string;
}): string[] {
  const byCode = useLocationLimits(policyYear, countryCode);
  const byName = useLocationLimits(policyYear, countryName);

  return useMemo(
    () => toStorageLocationOptions(byCode.data, byName.data),
    [byCode.data, byName.data],
  );
}
